<script>
import Chart from 'chart.js';
import { Line } from 'vue-chartjs'

const verticalLinePlugin = {
  renderVerticalLine: function (chart, point) {
    const ctx = chart.ctx
    const xAxis = chart.scales['x-axis-0']
    const yAxis = chart.scales['y-axis-0']
    const lineLeftOffset = xAxis.getPixelForValue(point.value)
    // render vertical line
    ctx.beginPath()
    ctx.strokeStyle = '#ff0000'
    ctx.moveTo(lineLeftOffset, yAxis.top)
    ctx.lineTo(lineLeftOffset, yAxis.bottom)
    ctx.stroke()
    // write label
    ctx.fillStyle = "#ff0000"
    ctx.textAlign = 'right'
    ctx.fillText(point.label, lineLeftOffset - 10, (yAxis.top + 20))
  },
  afterDatasetsDraw: function (chart, easing) {
    if (chart.config.data.lineAt) {
      chart.config.data.lineAt.forEach(point => {
        this.renderVerticalLine(chart, point)
      })
    }
  }
}

Chart.plugins.register(verticalLinePlugin)

export default {
  extends: Line,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  mounted () {
    this.renderChart(this.chartdata, this.options)
    const legend = this.$data._chart.generateLegend()
    this.$emit('generated', legend)
  }
}
</script>

<style>
</style>
